import React from "react"
import { faChevronRight, faDollarSign, faLocationDot, faStar } from "@fortawesome/free-solid-svg-icons"
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome"
import RetrieveImage from "../../../hooks/images/RetrieveImage"


interface CoachPreviewProps {
    id: string;
    fullname: string;
    specialization: string;
    location: string;
    rating: number;
    hideReviews?: boolean;
}

export default function CoachPreview(props:CoachPreviewProps){

    return (
        <div className="flex mx-auto mb-4 w-full justify-center items-center rounded-2xl bg-main-white border-2 border-main-grey-100 px-2 py-3.5 hover:border-main-green-500 hover:shadow-sm cursor-pointer">
            {props.id && (
                <RetrieveImage id={props.id} styling="w-12 h-12 md:w-16 md:h-14 my-auto mx-4 rounded-full border" />
            )}
            <div className="flex justify-start flex-wrap my-auto ml-2 mr-auto font-kulim">
                <h3 className="w-full text-bas lg:text-lg font-medium pb-2">{props.fullname}</h3>
                <div className="flex justify-center items-center text-sm my-0.5 mr-4">
                    <FontAwesomeIcon icon={faLocationDot}/>
                    <p className="ml-1.5">{props.location.length > 15 ? `${props.location.substring(0,12)}...`: props.location}</p>
                </div>
                {props.hideReviews && props.hideReviews ?
                    <></>
                :
                    <>
                        <FontAwesomeIcon 
                            icon={faStar} 
                            className="text-amber-500 w-4 my-auto mr-1.5"
                            aria-label="star icon associated with the reviews for this profile"
                        />
                        <p className="mr-4 text-sm my-auto">{Number(props.rating).toPrecision(2).toString().includes('0.0') ? '0 reviews' : Number(props.rating).toPrecision(2)}</p>
                    </>
                }
                <div className="bg-main-green-500 py-0.5 px-2.5 my-auto rounded-full mx-1">
                    <p className="text-xs md:text-sm text-main-white">{props.specialization}</p>
                </div>
            </div>
            <div className="flex ml-auto mr-3 my-auto w-fit text-main-grey-300 hover:text-main-green-500">
                <FontAwesomeIcon icon={faChevronRight} className="text-base m-auto ml-2"/>
            </div>
        </div>
    )
}